import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { listClients } from "../../api/bd";
import BackToDashboardButton from "@/components/BackToDashboardButton";
import HelpLink, { GUIDE_URLS } from "@/components/HelpLink";

const STATUS_LABEL = {
  not_started: "BD non démarrée",
  in_progress: "BD en cours",
  complete: "BD complète",
};
const STATUS_COLOR = {
  not_started: "bg-gray-100 text-gray-600",
  in_progress: "bg-amber-100 text-amber-800",
  complete: "bg-green-100 text-green-800",
};

export default function BDDashboard({ token, onBackToDashboard }) {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    listClients(token)
      .then((d) => alive && setClients(d.clients || []))
      .catch((e) => alive && setError(e?.response?.data?.detail || e.message))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, [token]);

  if (loading) return <div className="p-6">Chargement…</div>;
  if (error) return <div className="p-6 text-red-600">Erreur : {error}</div>;

  const handleBackToDashboard = () => {
    if (onBackToDashboard) onBackToDashboard();
    navigate("/");
  };

  return (
    <div className="p-6">
      <div className="module-header mb-4 flex items-center justify-between gap-4">
        <h1 className="module-title min-w-0 text-2xl font-bold">Module BD — Clients</h1>
        <div className="module-header-actions flex shrink-0 items-center gap-2">
          <HelpLink url={GUIDE_URLS.bd} />
          <BackToDashboardButton onClick={handleBackToDashboard} />
        </div>
      </div>
      {clients.length === 0 ? (
        <p className="text-gray-600">Aucune session autobio trouvée.</p>
      ) : (
        <ul className="space-y-2">
          {clients.map((c) => (
            <li
              key={c.client_id}
              className="p-3 border rounded hover:bg-gray-50 cursor-pointer flex items-center justify-between"
              onClick={() => navigate(`/bd/${encodeURIComponent(c.client_id)}`)}
            >
              <div>
                <div className="font-medium">{c.name}</div>
                <div className="text-xs text-gray-500">
                  {c.client_id}
                  {c.style_choisi && <span className="ml-2">· Style : {c.style_choisi}</span>}
                  {c.ambiance_choisie && <span className="ml-2">· Ambiance : {c.ambiance_choisie}</span>}
                </div>
              </div>
              <div className="flex items-center gap-3">
                {c.n_validated_chapters > 0 && (
                  <span className="text-xs text-gray-500">{c.n_validated_chapters}/5 chapitres ✓</span>
                )}
                <span className={`text-xs px-2 py-1 rounded ${STATUS_COLOR[c.bd_status]}`}>
                  {STATUS_LABEL[c.bd_status]}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
